import script from "./OurArea.vue?vue&type=script&setup=true&lang=js"
export * from "./OurArea.vue?vue&type=script&setup=true&lang=js"

import "./OurArea.vue?vue&type=style&index=0&id=26f2b95f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f2b95f"]])

export default __exports__